/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { DocumentDetailPublic } from './DocumentDetailPublic'
import {
  DocumentDetailPublicFromJSON,
  DocumentDetailPublicFromJSONTyped,
  DocumentDetailPublicToJSON,
} from './DocumentDetailPublic'

/**
 *
 * @export
 * @interface EnvelopedDocumentDocumentDetailPublic
 */
export interface EnvelopedDocumentDocumentDetailPublic {
  /**
   *
   * @type {DocumentDetailPublic}
   * @memberof EnvelopedDocumentDocumentDetailPublic
   */
  body: DocumentDetailPublic
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedDocumentDocumentDetailPublic
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedDocumentDocumentDetailPublic interface.
 */
export function instanceOfEnvelopedDocumentDocumentDetailPublic(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedDocumentDocumentDetailPublicFromJSON(
  json: any,
): EnvelopedDocumentDocumentDetailPublic {
  return EnvelopedDocumentDocumentDetailPublicFromJSONTyped(json, false)
}

export function EnvelopedDocumentDocumentDetailPublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedDocumentDocumentDetailPublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: DocumentDetailPublicFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedDocumentDocumentDetailPublicToJSON(
  value?: EnvelopedDocumentDocumentDetailPublic | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: DocumentDetailPublicToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
